export default "//static.tradera.net/touchweb/static/output/images/dpd.cbb66715.svg";